var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewRules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7331_18748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28711 8C1.91378 4.58667 4.90511 2 8.49978 2C12.0944 2 15.0851 4.58667 15.7124 8C15.0858 11.4133 12.0944 14 8.49978 14C4.90511 14 1.91444 11.4133 1.28711 8ZM8.49978 11.3333C9.38383 11.3333 10.2317 10.9821 10.8568 10.357C11.4819 9.7319 11.8331 8.88406 11.8331 8C11.8331 7.11595 11.4819 6.2681 10.8568 5.64298C10.2317 5.01786 9.38383 4.66667 8.49978 4.66667C7.61572 4.66667 6.76787 5.01786 6.14275 5.64298C5.51763 6.2681 5.16644 7.11595 5.16644 8C5.16644 8.88406 5.51763 9.7319 6.14275 10.357C6.76787 10.9821 7.61572 11.3333 8.49978 11.3333ZM8.49978 10C7.96934 10 7.46063 9.78929 7.08556 9.41421C6.71049 9.03914 6.49978 8.53043 6.49978 8C6.49978 7.46957 6.71049 6.96086 7.08556 6.58579C7.46063 6.21071 7.96934 6 8.49978 6C9.03021 6 9.53892 6.21071 9.91399 6.58579C10.2891 6.96086 10.4998 7.46957 10.4998 8C10.4998 8.53043 10.2891 9.03914 9.91399 9.41421C9.53892 9.78929 9.03021 10 8.49978 10Z",
    fill: "#141738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7331_18748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewRules);
export default __webpack_public_path__ + "static/media/viewRules.7804d6888753c6d68c66ebd256063157.svg";
export { ForwardRef as ReactComponent };